module.exports = __webpack_public_path__ + "static/media/onboarding-girl.768771ac.png";